import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { profileData } from '../data/mock';

const Blog = () => {
  return (
    <section id="blog" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Latest <span className="text-[#00AFF0]">Blog Posts</span>
          </h2>
          <div className="w-20 h-1 bg-[#00AFF0] mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Sharing insights, experiences, and technical deep-dives from my journey as a software engineer
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {profileData.blogs.map((blog) => (
            <Card
              key={blog.id}
              className="group overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border-2 hover:border-[#00AFF0]/30 cursor-pointer"
            >
              {/* Blog Image */}
              <div className="relative h-48 overflow-hidden bg-gradient-to-br from-[#00AFF0]/10 to-[#0099D6]/10">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <Badge className="bg-[#00AFF0] text-white hover:bg-[#0099D6]">
                    {blog.category}
                  </Badge>
                </div>
              </div>

              {/* Blog Content */}
              <div className="p-6 space-y-4">
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-[#00AFF0] transition-colors line-clamp-2">
                  {blog.title}
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed line-clamp-3">
                  {blog.excerpt}
                </p>

                {/* Meta Information */}
                <div className="flex items-center gap-4 text-sm text-gray-500 pt-2 border-t border-gray-100">
                  <span className="flex items-center gap-1">
                    <Calendar className="w-4 h-4" />
                    {blog.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <Clock className="w-4 h-4" />
                    {blog.readTime}
                  </span>
                </div>

                {/* Read More */}
                <button className="flex items-center gap-2 text-[#00AFF0] font-semibold group-hover:gap-3 transition-all duration-300">
                  Read More
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </Card>
          ))}
        </div>

        {/* View All Button */}
        <div className="mt-12 text-center">
          <button className="px-8 py-4 bg-[#00AFF0] text-white rounded-lg hover:bg-[#0099D6] transition-all duration-300 hover:shadow-lg hover:shadow-[#00AFF0]/30 font-semibold text-lg">
            View All Blog Posts
          </button>
        </div>
      </div>
    </section>
  );
};

export default Blog;
